import { t } from 'ttag'
import { useState } from 'react'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'

import { api } from '@h2/api'
import { useNavigator } from '@h2/common/components/hooks/useNavigator'
import { LESSON_UPDATED_EVENT } from '@h2/common/constants'
import { showUserFeedback } from '@h2/common/actions/showUserFeedback'
import { PillButton, PillLink, PillOutlineLink } from '@h2/features/planning/earlyStyles'

const LessonLinks = ({
  unfinishedAssignedOrUserInitiatedLessons,
  lessonToDisplay,
  renderStyleForNewLesson
}) => {
  const [selectedTaskId, setSelectedTaskId] = useState(null)
  const navigator = useNavigator()
  const reduxDispatch = useDispatch()
  const { mutate, isLoading } = useMutation(
    taskId => {
      setSelectedTaskId(taskId)

      /*
       * We use the goalId of 0 here since this isn't an actual goal. 0 will show up as persisted
       * and a valid id, but below the start of the db sequence.
       */
      return api.fetch(`/goals/0/${taskId}`, {
        method: 'POST',
        body: JSON.stringify({})
      })
    },
    {
      onSuccess: plan => {
        setSelectedTaskId(null)
        window.dispatchEvent(new CustomEvent(LESSON_UPDATED_EVENT))
        navigator(`/planning/assignments/detail/${plan.id}`)
      },
      onError: () => {
        setSelectedTaskId(null)
        reduxDispatch(
          showUserFeedback(t`Could not set active task within the selected goal`, 'error')
        )
      }
    }
  )
  const renderAssignedLessonLinks = () => {
    return (
      <>
        {renderStyleForNewLesson ? (
          <PillLink
            href={`/planning/assignments/detail/${lessonToDisplay.id}`}
            variant="button"
            fontSize="20px"
            weight="bold"
            isHoverStyled={false}>
            {t`Start New Lesson`}
          </PillLink>
        ) : (
          <>
            <PillOutlineLink
              href="/planning/goal"
              variant="outlined-cta"
              fontSize="20px"
              weight="bold"
              isHoverStyled={false}>
              {t`Start New Lesson`}
            </PillOutlineLink>
            <PillLink
              href={`/planning/assignments/detail/${lessonToDisplay.id}`}
              ssr
              variant="button"
              fontSize="20px"
              weight="bold"
              isHoverStyled={false}>
              {t`Continue Lesson`}
            </PillLink>
          </>
        )}
      </>
    )
  }
  const renderGradeLessonButtons = () => {
    return (
      <>
        {renderStyleForNewLesson ? (
          lessonToDisplay.id ? (
            <PillButton
              onClick={() => mutate(lessonToDisplay.id)}
              fontSize="20px"
              weight="bold"
              isLoading={isLoading && lessonToDisplay.id === selectedTaskId}>
              {t`Start New Lesson`}
            </PillButton>
          ) : (
            <PillOutlineLink
              href="/planning/goal"
              variant="outlined-cta"
              fontSize="20px"
              weight="bold"
              isHoverStyled={false}>
              {t`Start New Lesson`}
            </PillOutlineLink>
          )
        ) : (
          <>
            <PillOutlineLink
              href="/planning/goal"
              variant="outlined-cta"
              fontSize="20px"
              weight="bold"
              isHoverStyled={false}>
              {t`Start New Lesson`}
            </PillOutlineLink>
            <PillButton
              onClick={() => mutate(lessonToDisplay.id)}
              fontSize="20px"
              weight="bold"
              isLoading={isLoading && lessonToDisplay.id === selectedTaskId}>
              {t`Continue Lesson`}
            </PillButton>
          </>
        )}
      </>
    )
  }

  return (
    <>
      {/* grade lessons require different React components, therefore split logic unlike lessonInfo.js to maintain readability*/}
      {unfinishedAssignedOrUserInitiatedLessons
        ? renderAssignedLessonLinks()
        : renderGradeLessonButtons()}
    </>
  )
}

export { LessonLinks }
